import ArrowRightIcon from 'assets/ver2/icons/arrow-right-circle-outline-icon.svg';
import { isArray, isEmpty } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const HorizontalSwiper = ({
  data,
  styles = {},
  onClick = () => {},
  SlideItemComponent,
}) => {
  const [current, setCurrent] = useState(0);

  const dataLength = isArray(data) ? data?.length : 0;

  const handleOnClickSwiperSlideItem = (item) => {
    onClick(item);
  };
  const renderSlideItem = (item) => {
    if (!SlideItemComponent) return null;
    return <SlideItemComponent item={item} />;
  };
  const renderSwiperSlides = () => {
    if (isEmpty(data) || !isArray(data)) return null;
    return (
      <>
        {data.map((item, index) => (
          <SwiperSlides
            key={index}
            className={'swiper-slice-selected'}
            onClick={() => handleOnClickSwiperSlideItem(item)}
          >
            {renderSlideItem(item)}
          </SwiperSlides>
        ))}
      </>
    );
  };

  const handleOnPrev = (slide) => {
    const { activeIndex } = slide || {};
    setCurrent(activeIndex);
  };
  const handleOnNext = (slide) => {
    const { activeIndex } = slide || {};
    setCurrent(activeIndex);
  };
  const handleOnSwiper = (slide) => {
    const { activeIndex } = slide || {};
    setCurrent(activeIndex);
  };

  if (isEmpty(data)) return null;
  return (
    <SwiperStyled
      direction={'horizontal'}
      modules={[Navigation]}
      navigation={true}
      style={styles}
      onNavigationPrev={handleOnPrev}
      onNavigationNext={handleOnNext}
      onScroll={handleOnSwiper}
      onTransitionEnd={handleOnSwiper}
    >
      {renderSwiperSlides()}
      <SlideArrow>
        <ArrowLeft
          style={{ transform: 'rotate(180deg)' }}
          src={ArrowRightIcon}
          width={24}
          height={24}
          $isHide={current === 0}
        />
        <ArrowRight
          src={ArrowRightIcon}
          width={24}
          height={24}
          $isHide={current === dataLength - 1}
        />
      </SlideArrow>
    </SwiperStyled>
  );
};

const SwiperStyled = styled(Swiper)`
  height: fit-content;
  padding-bottom: 0px;
  width: calc(100% + 32px);
  margin-inline: -16px;

  & .swiper-wrapper {
    display: flex;
    align-items: center;
    gap: 0px;
    transform: ${(props) =>
      props.$translateX && `translate3d(${props.$translateX}, 0px, 0px)`};
  }

  & .swiper-scrollbar-horizontal {
    display: none;
  }

  & .swiper-button-prev,
  .swiper-button-next {
    color: transparent;
  }
`;

const SwiperSlides = styled(SwiperSlide)`
  width: 100% !important;
  height: fit-content;
  border-radius: 0px;

  &.swiper-slide-active {
  }

  &.swiper-slice-selected {
    background-color: transparent;
  }
`;

const SlideArrow = styled.div`
  height: 44px;
  width: calc(100% - 32px);
  margin-inline: 16px;
  background: transparent;
  position: absolute;
  top: calc(50% - 22px);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const ArrowLeft = styled.img`
  cursor: pointer;
  opacity: ${(props) => (props.$isHide ? 0.1 : 1)};
  z-index: 2;
`;
const ArrowRight = styled.img`
  cursor: pointer;
  opacity: ${(props) => (props.$isHide ? 0.1 : 1)};
  z-index: 2;
`;

export default HorizontalSwiper;
